// Config for the SERP Search & Scrape module.
//
// Inputs: Limit (1-3) and Search. Target is hard-coded to google_search.
//   Serpix request = { target: 'google_search', query: <search> } -> top-<limit> URLs -> Scrapix.

export const DEFAULT_LIMIT = 3;
export const MAX_LIMIT = 3;
export const TARGET = 'google_search';

// Shown under the Search input — users can type raw Google operators.
export const SEARCH_HINT = 'Supports Google operators — e.g. site:amazon.in toys, intitle:toys, "exact phrase", -exclude, OR, AROUND(3)';

// The input columns (manual grid + CSV).
export const INPUT_COLUMNS = [
  { key: 'limit', label: 'Limit', placeholder: '1-3', width: 80, type: 'number', help: 'URLs to scrape (1-3, default 3)' },
  { key: 'search', label: 'Search', placeholder: 'toys   (or: site:amazon.in toys)', width: 460, help: 'Serpix query — supports Google operators' },
];

// CSV header aliases → canonical row key.
export const CSV_HEADER_ALIASES = {
  limit: 'limit',
  search: 'search',
  'search string': 'search',
  'search query': 'search',
  query: 'search',
  q: 'search',
};

export const EMPTY_ROW = { limit: '', search: '' };

export const SAMPLE_CSV = [
  'Limit,Search',
  '2,toys',
  '1,site:amazon.in toys',
  '1,intitle:beauty products',
].join('\n');
